import { render, staticRenderFns } from "./card_management_info.vue?vue&type=template&id=20fad144&scoped=true"
import script from "./card_management_info.vue?vue&type=script&lang=js"
export * from "./card_management_info.vue?vue&type=script&lang=js"
import style0 from "./card_management_info.vue?vue&type=style&index=0&id=20fad144&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fad144",
  null
  
)

export default component.exports